import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './components/App';
import CollectionPage from './components/collections/CollectionPage';

export default (
	<Route path="/" component={App}>
		<IndexRoute component={CollectionPage} />
	</Route>
);


/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/